// Require vendors
global.$ = global.jQuery = require('jquery');
require('bootstrap');
var imagesLoaded = require('imagesloaded');
require('popper.js');

jQuery(function ($) {
    // change data-src to src to load the images
    // this is done now, so that large or external images will load after the DOM
    $('img[data-src]').each(function() {
        $(this).removeAttr("src");
        $(this).attr("src", $(this).attr('data-src'));
    });

    // Setup csrf token for all Ajax requests
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });


    // Disabled because it slows down the page quite a bit.
    // display loading until the page is loaded
    // we hide the page because otherwise things will pop into place
    // also needed to ensure that validator is loaded which helps the user experience
    // $('#main-container').imagesLoaded( function() {
    //     // $('#loading').addClass('hidden');
    //     // $('#loaded').removeClass('hidden');
    //
    //     // delay loading of background images for the homepage
    //     // they contain a loader message which will be removed after loading
    //     // https://stackoverflow.com/questions/5057990/how-can-i-check-if-a-background-image-is-loaded
    //     $('div[data-background-img]').each(function() {
    //         var div = $(this);
    //         $('<img/>').attr('src', div.attr('data-background-img')).on('load', function() {
    //             div.css('background-image', 'url(\''+div.attr('data-background-img')+'\')');
    //             div.empty();
    //         }.bind(div));
    //     });
    // });

    /* Enable bootstrap tooltips */
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-tooltip="tooltip"]').tooltip();

    // enable jquery validator http://1000hz.github.io/bootstrap-validator/
    $("form").validator({
        feedback: {
            success: '',
            error: ''
        }
    });

    /* Update hash in the addressbar */
    $("ul.nav-tabs > li > a").on("shown.bs.tab", function (e) {
        let scrollmemory = $('body').scrollTop() || $('html').scrollTop(); // scroll memory needed to stop weird scrolling
        let id = $(e.target).attr("href").substr(1);
        window.location.hash = id;
        $('html,body').scrollTop(scrollmemory);
    });

    // Show tab if that exists
    let hash = window.location.hash;
    if($('#tabs .nav-tabs a[href="' + hash + '"]').length) {
        $('#tabs .nav-tabs a[href="' + hash + '"]').tab('show');
    }

    // Change submit buttons to loaders when the form is submitted
    $('form').validator().on('submit', function (e) {
        if (! e.isDefaultPrevented()) { // the form is valid
            $(this).closest('form').find(':submit').html('<i class="fa fa-circle-o-notch fa-spin fa-fw" aria-hidden="true"></i>');
        }
    });
    $('.loader-on-click').click(function(e) {
        $(this).html('<i class="fa fa-circle-o-notch fa-spin fa-fw" aria-hidden="true"></i>');
    });

    /* Automatically close alerts */
    window.setTimeout(function() {
        $(".alert-temporary").fadeTo(500, 0).slideUp(500, function(){
            $(this).remove();
        });
    }, 30 * 1000); // milliseconds, 3000 is 3s

    /* Make a row clickable to a url */
    $(".clickable-row").click(function(e) {
        if(!$(e.target).closest('div').hasClass("btn-like-box")) { // When don't execute when clicking on the like button (or child elements)
            window.location = $(this).data("href");
        }
    });

    // reply button opens form below on ideas page
    $('.reply').click(function(e) {
        e.preventDefault(); // Prevent default action

        // Get the base ID by removing 'Btn_' if present
        let baseId = $(this).attr('id').replace('Btn_', '');

        // Show the container
        $('#' + baseId + 'Container').removeClass('d-none');

        // Scroll to the reply element
        if (baseId.indexOf("internal") >= 0) {
            $('#internal_comments_bar').animate({
                scrollTop: $('#' + baseId + 'Container').offset().top
            }, 500);
        } else {
            $('#main-container').animate({
                scrollTop: $('#' + baseId + 'Container').offset().top
            }, 500);
        }
    });

    // edit button opens form below on ideas page
    $('.edit').click(function() {
        $('#'+$(this).attr('id')+'_div').addClass('d-none');
        $('#edit_'+$(this).attr('id')+'_div').removeClass('d-none');
        $('#edit_'+$(this).attr('id')+'_div textarea').focus();
    });

    // cancel edit view
    $('.edit_comment .cancel').click(function() {
        $('#'+$(this).attr('data-target')+'_div').removeClass('d-none');
        $(this).closest('.edit_comment').addClass('d-none');
    });

    // cancel reply view
    $('.reply_comment .cancel').click(function() {
        $(this).closest('.reply_comment').addClass('d-none');
    });

    // Are you sure box
    $('.confirm').click(function() {
        return window.confirm("Are you sure?");
    });

    // Grow textbox with enters
    // @link https://stackoverflow.com/questions/2948230/auto-expand-a-textarea-using-jquery/10080841
    $("textarea").keyup(function(e) {
        while($(this).outerHeight() < this.scrollHeight) {
            $(this).height($(this).height()+1);
        };
    });

    // Update filename when using upload
    // Replace the "Choose a file" label with filename
    $('input[type="file"]').on('change',function(){
        var fileName = $(this).val();
        var fileName = fileName.replace("C:\\fakepath\\", ""); // HTML5 requests browsers to not show realpath
        $(this).next('.custom-file-label').html(fileName);
    })

    // ScrollTo function
    // source: https://stackoverflow.com/questions/6677035/jquery-scroll-to-element
    // Removing the elements height to scroll to the top of it
    jQuery.fn.scrollTo = function(elem, speed) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(elem).offset().top - $(elem).height()
        }, 1000);
        return this;
    };

    // Notifications
    // Are used in the navbar
    $('.mark-as-read').click(function() {
        $.ajax({
            method: "POST",
            cache: false,
            data: {id:$(this).attr('data-id')},
            url: '/notifications/mark_as_read',
            context: this
        }).done(function() {
            $(this).closest('li.notification').removeClass('notification-unread').addClass('notification-read');
            adjustNotificationCounter(-1);

        })
        .fail(function (jqXHRObject, textStatus, errorThrown) {
            console.log('hard error, cannot get response');
            console.log(textStatus + errorThrown);
            console.log(jqXHRObject);

            alert('Sorry, cannot perform action. Please contact support@productlift.dev');
        });
        return false;
    });

    $('.mark-as-unread').click(function() {
        $.ajax({
            method: "POST",
            cache: false,
            data: {id:$(this).attr('data-id')},
            url: '/notifications/mark_as_unread',
            context: this
        }).done(function() {
            $(this).closest('li.notification').addClass('notification-unread').removeClass('notification-read');
            adjustNotificationCounter(+1);

        })
        .fail(function (jqXHRObject, textStatus, errorThrown) {
            console.log('hard error, cannot get response');
            console.log(textStatus + errorThrown);
            console.log(jqXHRObject);

            alert('Sorry, cannot perform action. Please contact support@productlift.dev');
        });
        return false;
    });

    function adjustNotificationCounter(change) {
        let counters = $('.notification-counter');
        let icon = $('.navbar-notification-button .fa');
        let link = $('.navbar-notification-button');
        let current_counter = parseInt($('#notification_counter').val())
        let new_value = (current_counter + change)

        // Adjust styling
        // @todo: change ion icon
        if(current_counter === 0) { // expected to go to 1
            link.addClass('font-weight-bold');
        }
        if (new_value === 0) {
            link.removeClass('font-weight-bold');
        }

        // Save new value
        counters.text(new_value)
        $('#notification_counter').val(new_value)
    }



    /*
      Cookie alert to provide information about the privacy policy and cookies
     */

    function setCookie(key, value) {
        document.cookie = key + '=' + value + '; path=/; expires=Tue, 19 Jan 2038 03:14:07 UTC;';
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    $('#cookie_alert').offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)


    const privacy_cookie_name = 'ProductLiftPrivacyMessage'

    // Show the alert if we cant find the "acceptCookies" cookie
    if (!getCookie(privacy_cookie_name)) {
        $('#cookie_alert').removeClass('hidden');
    } else {
        // Safari's max lifetime for cookie is 7 days, so set it each time the page reloads
        setCookie(privacy_cookie_name, true);
    }

    // When clicking on the button, create a 1 year
    // cookie to remember user's choice and close the banner
    $('#noticedPrivacyMessage').click(function (e) {
        setCookie(privacy_cookie_name, true);
        $('#cookie_alert').hide();
    });

    // This will prevent the event from bubbling up and close the dropdown when you type/click on text boxes.
    $('.dropdown-menu input, .dropdown-menu select').click(function(e) {
        e.stopPropagation();
    });

    // When you click on the main commentbox, then display the markdown notification
    $('#post_main_comment_box_fake').click(function (e) {
        $('#post_main_comment_box_fake').addClass('d-none');
        $('#post_main_comment_box_full').removeClass('d-none');
        $('#post_main_comment_box_full textarea').focus();
    });


    /**
     * Like posts via ajax
     */
    $('div.container').on('click', "div.like-ajax.btn-can-like", function(event) {
        // Wait until previous click is finished
        if($(this).find( "i.fa.not-liked" ).hasClass('d-none')) return false;

        $(this).find( "i.fa.not-liked" ).addClass('d-none');
        $(this).find( "i.fa.loading" ).removeClass('d-none');

        $.ajax({
            method: "POST",
            cache: false,
            data: {id:$(this).attr('data-id')},
            url: '/posts/cast_vote',
            context: this
        }).done(function() {
            // Adjust icon and click-action
            $(this).find( "i.fa.liked" ).removeClass('d-none');
            $(this).find( "i.fa.loading" ).addClass('d-none');
            $(this).removeClass('btn-can-like').addClass('btn-liked');

            // Adjust counter
            let current_likes = parseInt($(this).find("span.likes").html())
            $(this).find("span.likes").html(current_likes + 1)
        })
            .fail(function (jqXHRObject, textStatus, errorThrown) {
                console.log('hard error, cannot get response');
                console.log(textStatus + errorThrown);
                console.log(jqXHRObject);

                alert('Sorry, cannot perform action. Please contact support@productlift.dev');
            });
        return false;
    });

    /**
     * Unlike posts via ajax
     */
    $('div.container').on('click', "div.like-ajax.btn-liked", function(event) {
        // Wait until previous click is finished
        if($(this).find( "i.fa.liked" ).hasClass('d-none')) return false;

        $(this).find( "i.fa.liked" ).addClass('d-none');
        $(this).find( "i.fa.loading" ).removeClass('d-none');

        $.ajax({
            method: "POST",
            cache: false,
            data: {id:$(this).attr('data-id')},
            url: '/posts/revoke_vote',
            context: this
        }).done(function() {
            // Adjust icon and click-action
            $(this).find( "i.fa.not-liked" ).removeClass('d-none');
            $(this).find( "i.fa.loading" ).addClass('d-none');
            $(this).removeClass('btn-liked').addClass('btn-can-like');

            // Adjust counter
            let current_likes = parseInt($(this).find("span.likes").html())
            $(this).find("span.likes").html(current_likes - 1)
        })
            .fail(function (jqXHRObject, textStatus, errorThrown) {
                console.log('hard error, cannot get response');
                console.log(textStatus + errorThrown);
                console.log(jqXHRObject);

                alert('Sorry, cannot perform action. Please contact support@productlift.dev');
            });
        return false;
    });

    // Add easy toggle buttons
    /**
     *  <button class="toggle-btn btn btn-primary">Toggle Text 2</button>
     *   <div class="toggle-text" style="display: none;">
     *     <p>This is the second text that gets toggled.</p>
     *   </div>
     */
    $(".toggle-btn").click(function() {
        let target = $(this).data("target");
        if(target) {
            $("#" + target).toggle('slow');
        } else {
            $(this).closest(".toggle-text").toggle('slow');
        }
    });

    $('.copy-btn').click(function() {
        // Create a temporary input element
        var $temp = $("<input>");
        $("body").append($temp);
        // Set its value to the URL
        $temp.val($(this).data('copy')).select();
        // Copy the value
        document.execCommand("copy");
        // Remove the temporary element
        $temp.remove();

        // Optional: Show a message that the URL was copied
        alert('Copied to clipboard!');
    });

    // Add anchor for knowledgebase, it is added in format markdown
    $('.anchor-link').each(function() {
        var anchor = $(this);
        var href = anchor.attr('href');

        if (href) {
            anchor.click(function(e) {
                e.preventDefault();
                var url = window.location.href.split('#')[0] + href;
                var tempInput = $('<input>');
                $('body').append(tempInput);
                tempInput.val(url).select();
                document.execCommand('copy');
                tempInput.remove();

                // Change the anchor icon to a check mark and color to green
                var icon = anchor.find('i');
                icon.removeClass('bi-link-45deg').addClass('bi-check').css('color', 'green');

                // Optionally, revert the icon and color back after a delay
                setTimeout(function() {
                    icon.removeClass('bi-check').addClass('bi-link-45deg').css('color', '');
                }, 2000);
            });
        }
    });



});

import Vue from 'vue';

/**
 * Load axios
 */
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = []; // for later, but needed for query string from the browser

// Create the router instance
const router = new VueRouter({
    mode: 'history',
    routes,
});

/**
 * Load Bootstrap Vue
 */
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { TooltipPlugin } from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(TooltipPlugin);


/**
 * Validator
 */
import {
    ValidationObserver,
    ValidationProvider,
    extend,
    localize
} from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";

// Configure vee-validate
import { configure } from 'vee-validate';

const config = {
    mode: 'eager'
};
configure(config);

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
extend('hex', {
    validate: (str) => {
        var pattern = new RegExp('^#[a-zA-Z0-9]{6}$');
        return !!pattern.test(str);
    },
    message: 'This is not a valid Hex color code.'
})
extend('subdomain', {
    validate: (str) => {
        var pattern = new RegExp('^[a-zA-Z0-9_\-]{3,50}$');
        return !!pattern.test(str);
    },
    message: 'This is not a valid subdomain.'
})
extend('license_code', {
    validate: (str) => {
        var pattern = new RegExp('^license[a-zA-Z0-9_\-]{20,50}$');
        return !!pattern.test(str);
    },
    message: 'This is not a valid license.'
})
localize("en", en);



Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Vue confetti
import VueConfetti from 'vue-confetti';
Vue.use(VueConfetti);

// Install copy to clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

// Filter for readable dates
Vue.filter('readableDate', function(value) {
    if (!value) return '';
    return new Date(value).toLocaleString();
});


import Vuex from 'vuex';

function prepareStore() {
    Vue.use(Vuex);

    const initialState = {};

    // Dynamically assign all properties from window.Laravel to the Vuex state
    if (window.Laravel && typeof window.Laravel === 'object') {
        Object.keys(window.Laravel).forEach(key => {
            initialState[key] = window.Laravel[key];
        });
    }

    const store = new Vuex.Store({
        state: initialState,
        // ... other Vuex configurations ...
    });

    return store
}



import i18n from './i18n';  // Import the i18n configuration




// Using Vue 2

import Categories from './components/Categories.vue'
if (location.pathname === '/admin/settings') {
    const app = new Vue({
        render: h => h(Categories)
    }).$mount('#categories_vue')
}

import JiraStatusMappings from './components/JiraStatusMappings.vue'
if (location.pathname === '/admin/settings') {
    const app = new Vue({
        render: h => h(JiraStatusMappings)
    }).$mount('#jira_status_mappings_vue')
}

import SignupAppsumo from './components/SignupAppsumo.vue'
if (location.pathname === '/signup/appsumo') {
    const app = new Vue({
        render: h => h(SignupAppsumo)
    }).$mount('#signup_appsumo_vue')
}

import StackMoreCodes from './components/StackMoreCodes.vue'
if (location.pathname === '/admin/account') {
    const app = new Vue({
        render: h => h(StackMoreCodes)
    }).$mount('#stack_more_codes_vue')
}

import ChangelogTool from './components/ChangelogTool.vue'
if (location.pathname === '/tools/changelog_generator') {
    const app = new Vue({
        render: h => h(ChangelogTool)
    }).$mount('#changelog_tool_vue')
}

import SprintNameTool from './components/SprintNameTool.vue'
if (location.pathname === '/tools/sprint_name_generator') {
    const app = new Vue({
        render: h => h(SprintNameTool)
    }).$mount('#sprint_name_tool_vue')
}

import TeamNameTool from './components/TeamNameTool.vue'
if (location.pathname === '/tools/team_name_generator') {
    const app = new Vue({
        render: h => h(TeamNameTool)
    }).$mount('#team_name_tool_vue')
}

import Signup from './components/Signup.vue'
if (location.pathname === '/signup') {
    const store = prepareStore()
    const app = new Vue({
        store,
        render: h => h(Signup)
    }).$mount('#signup_vue')
}

import GeneralLoginPortal from './components/GeneralLoginPortal.vue'
if (location.pathname === '/find_portal') {
    const store = prepareStore()
    const app = new Vue({
        store,
        render: h => h(GeneralLoginPortal)
    }).$mount('#login_vue')
}

import AddFeedbackWidget from './components/AddFeedbackWidget.vue'
if (location.pathname === '/add_feedback_widget') {
    const store = prepareStore()
    const app = new Vue({
        store,
        router,
        i18n,
        render: h => h(AddFeedbackWidget)
    }).$mount('#widget_vue')
}

import Feedback from './components/Feedback.vue'
if (location.pathname === '/admin/feedback') {
    const app = new Vue({
        render: h => h(Feedback)
    }).$mount('#feedback')
}

import Kanban from './components/Kanban.vue'
const kanbanElement = document.getElementById('kanban_vue');
if (kanbanElement) {
    const store = prepareStore()


    const app = new Vue({
        store,
        i18n,
        render: h => h(Kanban, {
            props: {
                dataSlug: kanbanElement.getAttribute('data-slug')
            }
        })
    }).$mount('#kanban_vue');
}

import BoardTemplates from './components/BoardTemplates.vue'
if (location.pathname === '/admin/load_templates') {
    const app = new Vue({
        render: h => h(BoardTemplates)
    }).$mount('#load_templates')
}
if (location.pathname === '/onboarding/select_tabs' || location.pathname === '/onboarding') {
    const app = new Vue({
        render: h => h(BoardTemplates)
    }).$mount('#onboarding_vue')
}

import NewPostPage from './pages/NewPostPage.vue'
if (location.pathname === '/new') {
    const store = prepareStore()

    const app = new Vue({
        store,
        i18n,
        render: h => h(NewPostPage)
    }).$mount('#new_post_vue')
}

import ManageStatuses from './components/ManageStatuses.vue'
if (location.pathname === '/admin/settings') {
    const store = prepareStore()
    const app = new Vue({
        store,
        render: h => h(ManageStatuses)
    }).$mount('#statuses_vue')
}

import ManageTags from './components/ManageTags.vue'
if (location.pathname === '/admin/settings') {
    const store = prepareStore()
    const app = new Vue({
        store,
        render: h => h(ManageTags)
    }).$mount('#tags_vue')
}

import ManageGroups from './components/ManageGroups.vue'
if (location.pathname === '/admin/settings') {
    const store = prepareStore()
    const app = new Vue({
        store,
        render: h => h(ManageGroups)
    }).$mount('#groups_vue')
}

import WhatsNewMiniWidget from './components/WhatsNewMiniWidget.vue'
if (location.pathname === '/whats_new_mini_widget') {
    const store = prepareStore()
    const app = new Vue({
        store,
        router,
        i18n,
        render: h => h(WhatsNewMiniWidget)
    }).$mount('#widget_vue')
}

import AddPostWidget from './components/AddPostWidget.vue'
if (location.pathname === '/add_post_widget') {
    const store = prepareStore()
    const app = new Vue({
        store,
        router,
        i18n,
        render: h => h(AddPostWidget)
    }).$mount('#widget_vue')
}

import Moderation from './components/Moderation.vue'
if (location.pathname === '/admin/moderation') {
    const store = prepareStore()
    const app = new Vue({
        store,
        render: h => h(Moderation)
    }).$mount('#moderation_vue')
}

import Prioritization from './components/Prioritization.vue'
if (location.pathname === '/admin/prioritization') {
    const store = prepareStore()
    const app = new Vue({
        store,
        i18n,
        render: h => h(Prioritization)
    }).$mount('#prioritization_vue')
}

import AiPrioritization from './components/AiPrioritization.vue'
if (location.pathname === '/admin/ai_prioritization') {
    const store = prepareStore()
    const app = new Vue({
        store,
        render: h => h(AiPrioritization)
    }).$mount('#ai_prioritization_vue')
}

import ProductVision from './components/ProductVision.vue'
if (location.pathname === '/admin/product_vision') {
    const store = prepareStore()
    const app = new Vue({
        store,
        render: h => h(ProductVision)
    }).$mount('#product_vision_vue')
}


import PostTags from './components/PostTags.vue'
const tagsElement = document.getElementById('vue_tags');
if (tagsElement) {
    const store = prepareStore()


    const app = new Vue({
        store,
        i18n,
        render: h => h(PostTags, {
            props: {
                postId: tagsElement.getAttribute('data-post-id')
            }
        })
    }).$mount('#vue_tags');
}

import LikeBox from './components/LikeBox.vue'
const likeBoxElement = document.getElementById('likebox_vue');
if (likeBoxElement) {
    const store = prepareStore()


    const app = new Vue({
        store,
        i18n,
        render: h => h(LikeBox, {
            props: {
                post: likeBoxElement.getAttribute('data-post'), // Remains a string
                votesCount: Number(likeBoxElement.getAttribute('data-votes-count')),
                displayNumberVotes: likeBoxElement.getAttribute('data-display-number-votes') === 'true',
                likeBoxClass: 'btn-like-box'
            }
        })
    }).$mount('#likebox_vue');
}
